import React from 'react';
import { Col, Row, Typography } from 'antd';

import styles from './index.module.scss';

interface InfoListProps {
  items: { label: string; value?: string | number, copyable?: boolean }[];
}

function DetailList({ items }: InfoListProps) {
  return (
    <Col span={24}>

      <Row gutter={12}>
        {items.map(({ label, value, copyable }) => (
          <Col key={label} span={12} className={styles.listItem}>
            <span className={styles.title}>{label}</span>
            <Typography.Text copyable={copyable}>{value || '-'}</Typography.Text>
          </Col>
        ))}
      </Row>
    </Col>

  );
}

export default DetailList;
